<template>
    <div class="card shadow-sm mb-3">
        <div class="card-body">
            <label>Contact facturation</label>
            <b-select
                v-model="invoicingContactId"
                size="sm"
                :class="reactiveClass"
                :options="contactOptions"
                @change="setInvoicingContact"
            />
        </div>
    </div>
</template>

<script>
import TableFormHandler from '../../../../common/mixins/TableFormHandler.vue'

export default {
    name: 'InvoicingContactSelect',
    mixins: [TableFormHandler],

    props: {
        companyId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            form: {
                client_id: null,
                client_contact_id: null,
                contact_type: null,
            },
            invoicingContactId: null,
            contactOptions: [{ text: 'Non défini', value: null }],
            defaultContacts: [],
            contacts: [],
            company: {},
        }
    },

    async created() {
        this.align = 'left'
        this.border = true
        await this.getContacts()
        await this.getDefaultContacts()
        this.form.client_id = this.companyId
    },

    methods: {
        async getContacts() {
            try {
                const response = await this.$axios.get(
                    `/clientContacts/${this.companyId}`
                )
                this.contacts = response.data.data
                this.setContactOptions()
            } catch (error) {
                //
            }
        },
        setContactOptions() {
            this.contactOptions = [{ text: 'Non défini', value: null }]
            for (let i = 0; i < this.contacts.length; i++) {
                this.contactOptions.push({
                    value: this.contacts[i].client_contact_id,
                    text: `${this.contacts[i].firstname} ${this.contacts[i].surname}`,
                })
            }
        },

        async getDefaultContacts() {
            try {
                const response = await this.$axios.get(
                    `/defaultContacts/${this.companyId}`
                )
                this.defaultContacts = response.data.data
                this.setDefaultContactIds()
            } catch (error) {
                //
            }
        },

        setDefaultContactIds() {
            if (this.defaultContacts.length > 0) {
                const invoicing = this.defaultContacts.find(
                    (item) => item.contact_type === 'invoicing'
                )
                this.invoicingContactId =
                    invoicing === null ? null : invoicing.client_contact_id
            }
        },

        async setInvoicingContact() {
            this.form.contact_type = 'invoicing'
            this.form.client_contact_id = this.invoicingContactId
            try {
                await this.$axios.post(`/defaultContacts`, this.form)
                this.handleSelectSuccess()
            } catch (error) {
                this.handleError()
            }
        },
    },
}
</script>

<style scoped></style>
